import { render, staticRenderFns } from "./restrictedList.vue?vue&type=template&id=452f745a&scoped=true"
import script from "./restrictedList.vue?vue&type=script&lang=js"
export * from "./restrictedList.vue?vue&type=script&lang=js"
import style0 from "./restrictedList.vue?vue&type=style&index=0&id=452f745a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f745a",
  null
  
)

export default component.exports